module.exports = __webpack_public_path__ + "static/img/IMG_20170101_000804-ANIMATION.04e52a0e.gif";